exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.handing-all-btn[data-v-df9e2482] {\n  margin-left: 20px;\n  margin-top: 20px;\n}\n.rule-table[data-v-df9e2482] {\n  margin: 10px 0;\n  width: 600px;\n}\n", ""]);

// exports
